import type { ChannelMiniEntity } from '@/features/channel/domain/entities/ChannelMiniEntity'

export class ChannelUserEntity {
  id?: number
  userId?: string
  userDisplayName?: string | null
  userPhoneNumber?: string | null
  userPhotoUrl?: string | null
  channels?: Array<ChannelMiniEntity> | null
}
